import { TCommonData, TLayout, TWidgetProps } from '@libs/types';
import clsx from 'clsx';
import React from 'react';
import { TLayoutOption } from '../../types/options';
import { getInlineStyles } from '../../utils/styles';
import styles from './Layout.module.css';

export const VerticalLayout: React.FC<TWidgetProps<TCommonData, TLayoutOption> & TLayout> = ({ widget, children, margin }) => {
    const classNames = clsx(
        styles.verticalLayoutInner,
        widget.options?.alignment && styles[`alignment-${widget.options?.alignment}`],
        widget.options?.arrangement && styles[`arrangement-${widget.options?.arrangement}`],
    );

    return (
        <div data-test={widget.uid} className={clsx('vertical-layout', styles.verticalLayout)}>
            <div className={classNames} style={getInlineStyles({ margin })}>
                {children}
            </div>
        </div>
    );
};
